"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  // FAILED_CONNECTION_NOTIFICATION: '',
  // Do not localize {Retry}; it is a placeholder for "Retry". English translation should be, "Send failed. Retry."
  SEND_FAILED_KEY: 'Impossibile inviare, {Retry}.',
  // SLOW_CONNECTION_NOTIFICATION: '',
  'Chat': 'Chat',
  'Download file': 'Download file',
  'Microphone off': 'Microfono spento',
  'Microphone on': 'Microfono acceso',
  'Listening…': 'Ascoltando…',
  'retry': 'riprova',
  'Retry': 'Riprova',
  // Please alter this value if 'Retry' at the beginning of a sentence is written differently than at the end of a sentence.
  'Send': 'Invia',
  'Sending': 'invio',
  'Speak': 'Parla',
  'Starting…': 'Inizializzando…',
  'Tax': 'Tasse',
  'Total': 'Totale',
  'Type your message': 'Scrivi il tuo messaggio',
  'Upload file': 'Carica un file',
  'VAT': 'IVA' // 'X minutes ago':

};
exports.default = _default;